import { getClassNameForField, newsFields as fields } from '../../constants'
import { useTranslationService } from '../../util/TranslationContext'
import { EditableFormPage } from '../components/EditableFormPage'

const NewsCreate = () => {
    const { translateFields } = useTranslationService()
    const newsFields = translateFields(fields, 'news')

    return (
        <>
            <EditableFormPage
                // title='Create News'
                submitUrl='admin/news'
                fields={newsFields}
                classNameForField={getClassNameForField}
                // loadingMessage='Loading...'
                errorMessage='Failed to fetch news data.'
                create={true}
                navigateLink='/admin/auth/news'
            />
        </>
    )
}

export default NewsCreate
